// // import React, { useState } from 'react';
// // import { ArrowRight, Cloud, Shield, Cog, BarChart3, Code } from 'lucide-react';

// // const DevOpsServicesPage = () => {
// //   const [activeService, setActiveService] = useState(null);

// //   const services = [
// //     {
// //       id: 1,
// //       title: 'DevOps Automation',
// //       description: 'Increase DevOps efficiency and reduce costs',
// //       icon: <Cog className="w-8 h-8 text-blue-500" />,
// //       details: 'Our DevOps automation services streamline your development pipeline, removing manual processes and reducing human error. We implement CI/CD pipelines, infrastructure as code, and automated testing to accelerate your delivery cycles while maintaining quality and stability.',
// //       benefits: ['Faster deployment cycles', 'Reduced operational costs', 'Improved code quality', 'Enhanced team collaboration'],
// //       cta: 'Optimize Your Pipeline'
// //     },
// //     {
// //       id: 2,
// //       title: 'Cloud Migration',
// //       description: 'Automate cloud based application deployments',
// //       icon: <Cloud className="w-8 h-8 text-blue-500" />,
// //       details: 'Whether youre moving to AWS, Azure, or Google Cloud, our cloud migration experts ensure a smooth transition with minimal downtime. We leverage automation to create repeatable, reliable deployment processes tailored to your specific cloud environment.',
// //       benefits: ['Seamless transition to cloud', 'Infrastructure as code implementation', 'Cost optimization', 'Scalable architecture design'],
// //       cta: 'Start Your Cloud Journey'
// //     },
// //     {
// //       id: 3,
// //       title: 'Compliance and Security',
// //       description: 'Speed up compliance and strengthen your security posture',
// //       icon: <Shield className="w-8 h-8 text-blue-500" />,
// //       details: 'Security isnt an afterthought—its built into everything we do. Our approach integrates compliance requirements and security best practices into your development workflow, ensuring your applications are secure by design without slowing down innovation.',
// //       benefits: ['Automated compliance checks', 'Security as code', 'Continuous vulnerability assessment', 'Regulatory framework alignment'],
// //       cta: 'Secure Your Infrastructure'
// //     },
// //     {
// //       id: 4,
// //       title: 'Platform Engineering',
// //       description: 'Scalable developer self-service',
// //       icon: <Code className="w-8 h-8 text-blue-500" />,
// //       details: 'We build internal developer platforms that empower your engineering teams with self-service capabilities. By abstracting away infrastructure complexity, we help developers focus on creating value rather than managing underlying systems.',
// //       benefits: ['Accelerated onboarding', 'Standardized workflows', 'Reduced cognitive load', 'Improved developer experience'],
// //       cta: 'Empower Your Developers'
// //     },
// //     {
// //       id: 5,
// //       title: 'Observability',
// //       description: 'Deeper insights into application performance',
// //       icon: <BarChart3 className="w-8 h-8 text-blue-500" />,
// //       details: 'Our observability solutions go beyond traditional monitoring to provide comprehensive insights into your systems. We implement logging, metrics, and tracing to help you understand not just whats happening, but why—enabling proactive issue resolution.',
// //       benefits: ['Real-time performance visibility', 'Anomaly detection', 'Reduced mean time to recovery', 'Data-driven decision making'],
// //       cta: 'Gain Deeper Insights'
// //     }
// //   ];

// //   return (
// //     <div className="bg-gradient-to-b from-gray-900 to-gray-800 min-h-screen text-white">
// //       {/* Hero Section */}
// //       <div className="container mx-auto px-4 py-16">
// //         <div className="max-w-4xl mx-auto text-center mb-16">
// //           <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
// //             Transforming DevOps Through Innovation
// //           </h1>
// //           <p className="text-xl text-gray-300 mb-8">
// //             Accelerate your delivery pipeline, strengthen security, and scale with confidence.
// //           </p>
// //           <div className="flex flex-wrap justify-center gap-4">
// //             <button className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium transition-all duration-300 flex items-center">
// //               Get Started <ArrowRight className="ml-2 w-5 h-5" />
// //             </button>
// //             <button className="px-6 py-3 bg-transparent border border-blue-500 hover:bg-blue-900/20 rounded-lg font-medium transition-all duration-300">
// //               Schedule Consultation
// //             </button>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Services Section */}
// //       <div className="container mx-auto px-4 py-16">
// //         <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">Our Services</h2>
        
// //         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
// //           {services.map((service) => (
// //             <div 
// //               key={service.id}
// //               className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm border border-gray-700 hover:border-blue-500 transition-all duration-300 cursor-pointer group"
// //               onClick={() => setActiveService(activeService === service.id ? null : service.id)}
// //             >
// //               <div className="mb-4 p-3 bg-gray-700/50 rounded-lg inline-block">
// //                 {service.icon}
// //               </div>
// //               <h3 className="text-xl font-bold mb-2 group-hover:text-blue-400 transition-colors duration-300">
// //                 {service.title}
// //               </h3>
// //               <p className="text-gray-400 mb-4">{service.description}</p>
              
// //               <div 
// //                 className={`overflow-hidden transition-all duration-500 ${
// //                   activeService === service.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
// //                 }`}
// //               >
// //                 <p className="text-gray-300 my-4">{service.details}</p>
// //                 <div className="mb-4">
// //                   <h4 className="font-medium text-blue-400 mb-2">Key Benefits:</h4>
// //                   <ul className="space-y-1">
// //                     {service.benefits.map((benefit, index) => (
// //                       <li key={index} className="flex items-start">
// //                         <span className="text-blue-500 mr-2">•</span>
// //                         <span className="text-gray-300">{benefit}</span>
// //                       </li>
// //                     ))}
// //                   </ul>
// //                 </div>
// //                 <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium mt-2 transition-all duration-300 flex items-center text-sm">
// //                   {service.cta} <ArrowRight className="ml-2 w-4 h-4" />
// //                 </button>
// //               </div>
              
// //               <div className={`mt-4 text-blue-400 flex items-center text-sm font-medium ${
// //                 activeService === service.id ? 'hidden' : 'block'
// //               }`}>
// //                 Learn more <ArrowRight className="ml-1 w-4 h-4" />
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       {/* CTA Section */}
// //       <div className="container mx-auto px-4 py-16">
// //         <div className="max-w-4xl mx-auto bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 md:p-12">
// //           <div className="flex flex-col md:flex-row items-center justify-between">
// //             <div className="mb-6 md:mb-0">
// //               <h3 className="text-2xl md:text-3xl font-bold mb-4">Ready to transform your DevOps practice?</h3>
// //               <p className="text-blue-100">Schedule a consultation with our experts to discuss your specific needs.</p>
// //             </div>
// //             <button className="px-6 py-3 bg-white text-blue-600 hover:bg-gray-100 rounded-lg font-medium transition-all duration-300 whitespace-nowrap">
// //               Book a Call
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DevOpsServicesPage;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Link, useParams, useNavigate } from 'react-router-dom';
// import { ArrowRight, ArrowLeft, Cloud, Shield, Cog, BarChart3, Code } from 'lucide-react';

// // Services Data
// const servicesData = [
//   {
//     id: 'devops-automation',
//     title: 'DevOps Automation',
//     description: 'Increase DevOps efficiency and reduce costs',
//     icon: <Cog className="w-8 h-8 text-blue-500" />,
//     details: 'Our DevOps automation services streamline your development pipeline, removing manual processes and reducing human error. We implement CI/CD pipelines, infrastructure as code, and automated testing to accelerate your delivery cycles while maintaining quality and stability.',
//     benefits: ['Faster deployment cycles', 'Reduced operational costs', 'Improved code quality', 'Enhanced team collaboration'],
//     features: [
//       {
//         title: 'Continuous Integration & Deployment',
//         description: 'Automate your build, test, and deployment processes to deliver software faster and more reliably.'
//       },
//       {
//         title: 'Infrastructure as Code',
//         description: 'Define and provision your infrastructure using code for consistency, repeatability, and version control.'
//       },
//       {
//         title: 'Automated Testing',
//         description: 'Implement comprehensive automated testing strategies to catch issues early and ensure quality.'
//       },
//       {
//         title: 'Configuration Management',
//         description: 'Automate the management of your application configurations across different environments.'
//       }
//     ],
//     cta: 'Optimize Your Pipeline',
//     process: [
//       'Assessment of current workflow',
//       'Identification of automation opportunities',
//       'Implementation of CI/CD pipelines',
//       'Integration of monitoring and alerts'
//     ]
//   },
//   {
//     id: 'cloud-migration',
//     title: 'Cloud Migration',
//     description: 'Automate cloud based application deployments',
//     icon: <Cloud className="w-8 h-8 text-blue-500" />,
//     details: 'Whether youre moving to AWS, Azure, or Google Cloud, our cloud migration experts ensure a smooth transition with minimal downtime. We leverage automation to create repeatable, reliable deployment processes tailored to your specific cloud environment.',
//     benefits: ['Seamless transition to cloud', 'Infrastructure as code implementation', 'Cost optimization', 'Scalable architecture design'],
//     features: [
//       {
//         title: 'Cloud Assessment',
//         description: 'Evaluate your current infrastructure and applications to develop a tailored migration strategy.'
//       },
//       {
//         title: 'Migration Planning',
//         description: 'Create a detailed roadmap for moving your applications and data to the cloud with minimal disruption.'
//       },
//       {
//         title: 'Automated Deployments',
//         description: 'Implement repeatable, automated deployment processes for your cloud-based applications.'
//       },
//       {
//         title: 'Cloud Optimization',
//         description: 'Continuously monitor and optimize your cloud resources for performance and cost efficiency.'
//       }
//     ],
//     cta: 'Start Your Cloud Journey',
//     process: [
//       'Discovery and assessment',
//       'Migration planning and strategy',
//       'Implementation and testing',
//       'Optimization and management'
//     ]
//   },
//   {
//     id: 'compliance-security',
//     title: 'Compliance and Security',
//     description: 'Speed up compliance and strengthen your security posture',
//     icon: <Shield className="w-8 h-8 text-blue-500" />,
//     details: 'Security isnt an afterthought—its built into everything we do. Our approach integrates compliance requirements and security best practices into your development workflow, ensuring your applications are secure by design without slowing down innovation.',
//     benefits: ['Automated compliance checks', 'Security as code', 'Continuous vulnerability assessment', 'Regulatory framework alignment'],
//     features: [
//       {
//         title: 'Security as Code',
//         description: 'Embed security controls directly into your infrastructure and application code.'
//       },
//       {
//         title: 'Automated Compliance',
//         description: 'Build automated checks for industry standards like HIPAA, SOC2, PCI DSS, and GDPR into your CI/CD pipeline.'
//       },
//       {
//         title: 'Vulnerability Management',
//         description: 'Continuously scan for vulnerabilities in your code, dependencies, and infrastructure.'
//       },
//       {
//         title: 'Identity and Access Management',
//         description: 'Implement robust access controls and authentication mechanisms to protect your systems.'
//       }
//     ],
//     cta: 'Secure Your Infrastructure',
//     process: [
//       'Security assessment',
//       'Compliance gap analysis',
//       'Implementation of security controls',
//       'Continuous monitoring and improvement'
//     ]
//   },
//   {
//     id: 'platform-engineering',
//     title: 'Platform Engineering',
//     description: 'Scalable developer self-service',
//     icon: <Code className="w-8 h-8 text-blue-500" />,
//     details: 'We build internal developer platforms that empower your engineering teams with self-service capabilities. By abstracting away infrastructure complexity, we help developers focus on creating value rather than managing underlying systems.',
//     benefits: ['Accelerated onboarding', 'Standardized workflows', 'Reduced cognitive load', 'Improved developer experience'],
//     features: [
//       {
//         title: 'Internal Developer Platforms',
//         description: 'Build self-service platforms that abstract infrastructure complexity for your development teams.'
//       },
//       {
//         title: 'API Gateway Management',
//         description: 'Implement and manage API gateways to standardize and secure service communications.'
//       },
//       {
//         title: 'Service Mesh',
//         description: 'Deploy service mesh architectures to manage microservices communication and traffic.'
//       },
//       {
//         title: 'Developer Portals',
//         description: 'Create intuitive portals for developers to discover, understand, and consume internal services.'
//       }
//     ],
//     cta: 'Empower Your Developers',
//     process: [
//       'Assessment of developer needs',
//       'Platform architecture design',
//       'Implementation and integration',
//       'Documentation and training'
//     ]
//   },
//   {
//     id: 'observability',
//     title: 'Observability',
//     description: 'Deeper insights into application performance',
//     icon: <BarChart3 className="w-8 h-8 text-blue-500" />,
//     details: 'Our observability solutions go beyond traditional monitoring to provide comprehensive insights into your systems. We implement logging, metrics, and tracing to help you understand not just whats happening, but why—enabling proactive issue resolution.',
//     benefits: ['Real-time performance visibility', 'Anomaly detection', 'Reduced mean time to recovery', 'Data-driven decision making'],
//     features: [
//       {
//         title: 'Distributed Tracing',
//         description: 'Implement end-to-end tracing across your microservices to understand request flows and identify bottlenecks.'
//       },
//       {
//         title: 'Centralized Logging',
//         description: 'Collect, aggregate, and analyze logs from all your applications and infrastructure in one place.'
//       },
//       {
//         title: 'Metrics and Monitoring',
//         description: 'Set up comprehensive metrics collection and visualization to track system health and performance.'
//       },
//       {
//         title: 'Alerting and Incident Response',
//         description: 'Configure intelligent alerting and automated incident response workflows.'
//       }
//     ],
//     cta: 'Gain Deeper Insights',
//     process: [
//       'Observability strategy development',
//       'Implementation of logging, metrics, and tracing',
//       'Dashboard and visualization setup',
//       'Alert configuration and tuning'
//     ]
//   }
// ];

// // Navbar Component
// const Navbar = () => {
//   return (
//     <nav className="bg-gray-900 py-4 px-6">
//       <div className="container mx-auto flex justify-between items-center">
//         <Link to="/" className="text-2xl font-bold text-white">
//           DevOps<span className="text-blue-500">Pro</span>
//         </Link>
//         <div className="hidden md:flex space-x-6">
//           <Link to="/" className="text-gray-300 hover:text-white transition-colors">Home</Link>
//           <Link to="/services" className="text-gray-300 hover:text-white transition-colors">Services</Link>
//           <Link to="/about" className="text-gray-300 hover:text-white transition-colors">About</Link>
//           <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link>
//         </div>
//         <button className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors">
//           Get Started
//         </button>
//       </div>
//     </nav>
//   );
// };

// // Footer Component
// const Footer = () => {
//   return (
//     <footer className="bg-gray-900 py-12 px-6">
//       <div className="container mx-auto">
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//           <div>
//             <h3 className="text-xl font-bold text-white mb-4">DevOps<span className="text-blue-500">Pro</span></h3>
//             <p className="text-gray-400">Accelerating digital transformation through innovative DevOps solutions.</p>
//           </div>
//           <div>
//             <h4 className="text-lg font-medium text-white mb-4">Services</h4>
//             <ul className="space-y-2">
//               {servicesData.map(service => (
//                 <li key={service.id}>
//                   <Link to={`/services/${service.id}`} className="text-gray-400 hover:text-blue-400 transition-colors">
//                     {service.title}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>
//           <div>
//             <h4 className="text-lg font-medium text-white mb-4">Company</h4>
//             <ul className="space-y-2">
//               <li><Link to="/about" className="text-gray-400 hover:text-blue-400 transition-colors">About Us</Link></li>
//               <li><Link to="/careers" className="text-gray-400 hover:text-blue-400 transition-colors">Careers</Link></li>
//               <li><Link to="/blog" className="text-gray-400 hover:text-blue-400 transition-colors">Blog</Link></li>
//               <li><Link to="/contact" className="text-gray-400 hover:text-blue-400 transition-colors">Contact</Link></li>
//             </ul>
//           </div>
//           <div>
//             <h4 className="text-lg font-medium text-white mb-4">Connect</h4>
//             <div className="flex space-x-4">
//               <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
//                 <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                   <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
//                 </svg>
//               </a>
//               <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
//                 <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                   <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
//                 </svg>
//               </a>
//               <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
//                 <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                   <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
//                 </svg>
//               </a>
//               <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
//                 <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
//                   <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
//                 </svg>
//               </a>
//             </div>
//           </div>
//         </div>
//         <div className="mt-12 pt-8 border-t border-gray-800 text-gray-400 text-center">
//           <p>&copy; {new Date().getFullYear()} DevOpsPro. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// // Service Card Component
// const ServiceCard = ({ service }) => {
//   const navigate = useNavigate();
  
//   return (
//     <div 
//       className="bg-gray-800/50 p-6 rounded-xl backdrop-blur-sm border border-gray-700 hover:border-blue-500 transition-all duration-300 cursor-pointer group"
//       onClick={() => navigate(`/services/${service.id}`)}
//     >
//       <div className="mb-4 p-3 bg-gray-700/50 rounded-lg inline-block">
//         {service.icon}
//       </div>
//       <h3 className="text-xl font-bold mb-2 group-hover:text-blue-400 transition-colors duration-300">
//         {service.title}
//       </h3>
//       <p className="text-gray-400 mb-4">{service.description}</p>
      
//       <div className="mt-4 text-blue-400 flex items-center text-sm font-medium">
//         Learn more <ArrowRight className="ml-1 w-4 h-4" />
//       </div>
//     </div>
//   );
// };

// // Services List Page
// const SolutionsPage = () => {
//   return (
//     <div className="bg-gradient-to-b from-gray-900 to-gray-800 min-h-screen text-white">
//       {/* Hero Section */}
//       <div className="container mx-auto px-4 py-16">
//         <div className="max-w-4xl mx-auto text-center mb-16">
//           <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
//             Our DevOps Services
//           </h1>
//           <p className="text-xl text-gray-300 mb-8">
//             Accelerate your delivery pipeline, strengthen security, and scale with confidence
//           </p>
//         </div>
//       </div>

//       {/* Services Grid */}
//       <div className="container mx-auto px-4 py-8">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {servicesData.map((service) => (
//             <ServiceCard key={service.id} service={service} />
//           ))}
//         </div>
//       </div>

//       {/* CTA Section */}
//       <div className="container mx-auto px-4 py-16">
//         <div className="max-w-4xl mx-auto bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 md:p-12">
//           <div className="flex flex-col md:flex-row items-center justify-between">
//             <div className="mb-6 md:mb-0">
//               <h3 className="text-2xl md:text-3xl font-bold mb-4">Ready to transform your DevOps practice?</h3>
//               <p className="text-blue-100">Schedule a consultation with our experts to discuss your specific needs.</p>
//             </div>
//             <button className="px-6 py-3 bg-white text-blue-600 hover:bg-gray-100 rounded-lg font-medium transition-all duration-300 whitespace-nowrap">
//               Book a Call
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Service Detail Page
// const ServiceDetailPage = () => {
//   const { serviceId } = useParams();
//   const navigate = useNavigate();
//   const service = servicesData.find(s => s.id === serviceId);

//   if (!service) {
//     return <div className="text-center py-16">Service not found</div>;
//   }

//   return (
//     <div className="bg-gradient-to-b from-gray-900 to-gray-800 min-h-screen text-white">
//       {/* Hero Section */}
//       <div className="container mx-auto px-4 py-16">
//         <button 
//           onClick={() => navigate('/services')}
//           className="flex items-center text-blue-400 hover:text-blue-300 transition-colors mb-8"
//         >
//           <ArrowLeft className="mr-2 w-5 h-5" /> Back to Services
//         </button>
        
//         <div className="max-w-4xl mx-auto mb-16">
//           <div className="flex items-center mb-6">
//             <div className="p-4 bg-blue-500/20 rounded-lg mr-4">
//               {service.icon}
//             </div>
//             <h1 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
//               {service.title}
//             </h1>
//           </div>
//           <p className="text-xl text-gray-300 mb-8">
//             {service.description}
//           </p>
//           <p className="text-gray-300 mb-8">
//             {service.details}
//           </p>
//         </div>
//       </div>

//       {/* Benefits Section */}
//       <div className="container mx-auto px-4 py-8">
//         <div className="max-w-4xl mx-auto">
//           <h2 className="text-2xl md:text-3xl font-bold mb-8">Key Benefits</h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {service.benefits.map((benefit, index) => (
//               <div key={index} className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
//                 <div className="flex items-center mb-4">
//                   <div className="text-blue-500 mr-3">
//                     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
//                     </svg>
//                   </div>
//                   <h3 className="text-lg font-medium">{benefit}</h3>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Features Section */}
//       <div className="container mx-auto px-4 py-16">
//         <div className="max-w-4xl mx-auto">
//           <h2 className="text-2xl md:text-3xl font-bold mb-8">What We Offer</h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {service.features.map((feature, index) => (
//               <div key={index} className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
//                 <h3 className="text-xl font-bold mb-4 text-blue-400">{feature.title}</h3>
//                 <p className="text-gray-300">{feature.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Process Section */}
//       <div className="container mx-auto px-4 py-16">
//         <div className="max-w-4xl mx-auto">
//           <h2 className="text-2xl md:text-3xl font-bold mb-8">Our Process</h2>
//           <div className="relative">
//             {service.process.map((step, index) => (
//               <div key={index} className="flex mb-12 last:mb-0">
//                 <div className="mr-6 relative">
//                   <div className="flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold relative z-10">
//                     {index + 1}
//                   </div>
//                   {index < service.process.length - 1 && (
//                     <div className="absolute top-10 bottom-0 left-5 w-0.5 bg-blue-600/30"></div>
//                   )}
//                 </div>
//                 <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 flex-1">
//                   <h3 className="text-xl font-bold mb-2">{step}</h3>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* CTA Section */}
//       <div className="container mx-auto px-4 py-16">
//         <div className="max-w-4xl mx-auto bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 md:p-12">
//           <div className="text-center mb-8">
//             <h3 className="text-2xl md:text-3xl font-bold mb-4">Ready to get started with {service.title}?</h3>
//             <p className="text-blue-100">Our team of experts is ready to help you implement the right solutions for your business.</p>
//           </div>
//           <div className="flex justify-center">
//             <button className="px-8 py-4 bg-white text-blue-600 hover:bg-gray-100 rounded-lg font-medium text-lg transition-all duration-300">
//               {service.cta}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };



// export {SolutionsPage, ServiceDetailPage};

import React, { useEffect } from 'react';
import { ArrowRight, Cog, GitBranch, Code, Server, BarChart } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

const SolutionsPage = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div>
             <Header />
    <div className="bg-gradient-to-b from-gray-900 to-gray-800 min-h-screen text-white">
      {/* Header/Nav */}

      {/* Hero Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
              <div className="p-4 inline-block bg-blue-500/20 rounded-xl mb-4">
                <Cog className="w-12 h-12 text-blue-500" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
                DevOps <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">Automation</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Increase DevOps efficiency and reduce costs
              </p>
              <p className="text-gray-300 mb-8">
                Our DevOps automation services streamline your development pipeline, removing manual processes and reducing human error. We implement CI/CD pipelines, infrastructure as code, and automated testing to accelerate your delivery cycles while maintaining quality and stability.
              </p>
              <button className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg transition-colors flex items-center">
                Get Started <ArrowRight className="ml-2 w-5 h-5" />
              </button>
            </div>
            <div className="md:w-1/2">
              <div className="bg-gray-800 p-6 rounded-2xl border border-gray-700 shadow-lg">
                <img src="/api/placeholder/600/400" alt="DevOps Automation" className="rounded-lg w-full" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4 bg-gray-900/50">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold mb-12 text-center">Key Benefits</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Faster Deployment Cycles</h3>
              <p className="text-gray-300">Automate your pipeline to reduce time between development and production, enabling faster feature delivery and bug fixes.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Reduced Operational Costs</h3>
              <p className="text-gray-300">Minimize infrastructure costs, eliminate manual work, and optimize resource utilization with automated scaling and management.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Improved Code Quality</h3>
              <p className="text-gray-300">Implement automated testing and code analysis to catch issues early and ensure consistent code quality standards.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Enhanced Team Collaboration</h3>
              <p className="text-gray-300">Standardize processes and workflows to improve communication and collaboration between development and operations teams.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold mb-12 text-center">Our DevOps Automation Services</h2>
          <div className="space-y-8">
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <GitBranch className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">CI/CD Pipeline Implementation</h3>
                  <p className="text-gray-300 mb-4">
                    We build and optimize continuous integration and continuous deployment pipelines that automate your software delivery process from code commit to production deployment.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Automated build and test processes</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Seamless integration with version control systems</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Deployment automation for consistent releases</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <Code className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Infrastructure as Code</h3>
                  <p className="text-gray-300 mb-4">
                    Define and manage your infrastructure using code, enabling consistent, repeatable, and version-controlled infrastructure provisioning and management.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Terraform, CloudFormation, and ARM templates</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Configuration management with Ansible, Chef, or Puppet</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Immutable infrastructure patterns</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <Server className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Containerization & Orchestration</h3>
                  <p className="text-gray-300 mb-4">
                    Modernize your applications with containerization and implement orchestration solutions for efficient container management and scaling.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Docker containerization</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Kubernetes orchestration</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Service mesh implementation</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <BarChart className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Monitoring & Alerting Automation</h3>
                  <p className="text-gray-300 mb-4">
                    Implement comprehensive monitoring and alerting systems that provide real-time visibility into your infrastructure and applications.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Automated metric collection and visualization</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Intelligent alerting and notification systems</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Log aggregation and analysis</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 px-4 bg-gray-900/50">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold mb-12 text-center">Our Implementation Process</h2>
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 ml-0 md:-ml-1 top-0 h-full w-0.5 bg-blue-500/30"></div>
            
            <div className="space-y-16">
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-1 md:w-1/2 pr-0 md:pr-8 pb-8 md:pb-0 flex justify-start md:justify-end">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">1. Assessment & Discovery</h3>
                    <p className="text-gray-300">We analyze your current development and operations processes to identify improvement opportunities and automation candidates.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  1
                </div>
                <div className="order-3 md:order-3 md:w-1/2 pl-8 md:pl-8 flex justify-start invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-3 md:w-1/2 pl-0 md:pl-8 pb-8 md:pb-0 flex justify-start">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">2. Strategy & Planning</h3>
                    <p className="text-gray-300">We develop a tailored automation strategy and roadmap aligned with your business goals and technical requirements.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  2
                </div>
                <div className="order-3 md:order-1 md:w-1/2 pr-8 md:pr-8 flex justify-end invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-1 md:w-1/2 pr-0 md:pr-8 pb-8 md:pb-0 flex justify-start md:justify-end">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">3. Implementation & Integration</h3>
                    <p className="text-gray-300">We implement the automation solutions and integrate them with your existing tools and workflows.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  3
                </div>
                <div className="order-3 md:order-3 md:w-1/2 pl-8 md:pl-8 flex justify-start invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-3 md:w-1/2 pl-0 md:pl-8 pb-8 md:pb-0 flex justify-start">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">4. Testing & Validation</h3>
                    <p className="text-gray-300">We thoroughly test the automated processes to ensure they meet requirements and function as expected.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  4
                </div>
                <div className="order-3 md:order-1 md:w-1/2 pr-8 md:pr-8 flex justify-end invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-1 md:w-1/2 pr-0 md:pr-8 pb-8 md:pb-0 flex justify-start md:justify-end">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">5. Training & Knowledge Transfer</h3>
                    <p className="text-gray-300">We provide comprehensive training to ensure your team can effectively use and maintain the automation systems.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  5
                </div>
                <div className="order-3 md:order-3 md:w-1/2 pl-8 md:pl-8 flex justify-start invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 md:p-12">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold mb-4">Ready to automate your DevOps processes?</h2>
              <p className="text-blue-100 max-w-2xl mx-auto">
                Let our experts help you implement the right automation solutions to increase efficiency, reduce costs, and accelerate your delivery pipeline.
              </p>
            </div>
            <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-6">
              <button className="w-full md:w-auto bg-white text-blue-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg transition-colors">
                Schedule a Consultation
              </button>
              <button className="w-full md:w-auto bg-transparent border border-white text-white hover:bg-blue-700/50 font-bold py-3 px-8 rounded-lg transition-colors">
                View Case Studies
              </button>
            </div>
          </div>
        </div>
      </section>
     </div>
     <Footer />
     </div>
  )
}
export {SolutionsPage};